export default __webpack_public_path__ + "static/media/baseline-battery_charging_50-24px.a87100b3.svg";